// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import { toast } from 'react-toastify';

// Internal Dependencies
import MText from '../../../../../components/Common/MText';
import ApiService from '../../../../../services/apiService';

const columns = [
  { title: 'Outlet ID', filtering: true, field: 'outletId', editable: 'never' },
  { title: 'Brand', filtering: true, field: 'outletName', editable: 'never' },
  { title: 'Address', filtering: true, field: 'address', editable: 'never' },
  { title: 'Tel', filtering: true, field: 'tel', editable: 'never' },
];

const ParticipatingOutlets = ({ gift }) => {
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const getParticipateOutlets = async () => {
    try {
      setIsLoading(true);
      const results = await ApiService.getGiftParticipateOutlets(gift.pageId, gift.id);
      setData(results.rows);
      setTotalCount(results.totalCount);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getParticipateOutlets();
  }, []);

  return (
    <>
      <div className="mb-4">
        <table>
          <tr>
            <td className="w-25">
              <MText text={`${gift.type} ID:`} size="0.875rem" />
            </td>
            <td>
              <MText bold text={gift.id} size="0.875rem" />
            </td>
          </tr>
          <tr>
            <td>
              <MText text="Description:" size="0.875rem" />
            </td>
            <td>
              <MText bold text={gift.label} size="0.875rem" />
            </td>
          </tr>
        </table>
      </div>

      <div>
        <MText variant="body2" size={null} className="mb-2" text="Participating Outlets" />
        <MaterialTable
          columns={columns}
          isLoading={isLoading}
          components={{ Toolbar: () => null }}
          options={{ filtering: true, search: false, debounceInterval: 500, emptyRowsWhenPaging: false }}
          data={data}
        />

        <div className="mt-1">
          <MText text={`Total: ${totalCount}`} size="0.875rem" />
        </div>
      </div>

      <div className="container-fluid text-center">
        <MText text="Note: Please reach out to the Monstyr team if any amendment is required" size="0.875rem" />
      </div>
    </>
  );
};

ParticipatingOutlets.propTypes = {
  gift: PropTypes.shape({
    label:  PropTypes.string,
    id:     PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    type:   PropTypes.string,
    pageId: PropTypes.number,
  }).isRequired,
};

export default ParticipatingOutlets;
